import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SvgIcon from '../SvgIcon';
import Text from './Text';
import { colors } from '@styles/theme';
import {
  borderRadius,
  buttonStyle,
  space,
  fontSize,
  fontWeight,
  lineHeight,
  flexbox,
  width,
  background
} from 'styled-system';

const Wrapper = styled('button')`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  outline: 0;
  cursor: pointer;

  background: transparent;

  &:enabled {
    color: ${colors.darkGold};
    ${props =>
      props.name !== 'minte-logo'
        ? {
            path: {
              '&:last-child': {
                fill: colors.gold
              }
            }
          }
        : ''}
  }

  &:disabled {
    color: ${colors.lightGold};
    ${props =>
      props.name !== 'minte-logo'
        ? {
            path: {
              '&:last-child': {
                fill: colors.lightGold
              }
            }
          }
        : ''}
  }

  &:hover {
    color: ${colors.lightGold};
    ${props =>
      props.name !== 'minte-logo'
        ? {
            path: {
              '&:last-child': {
                fill: colors.lightGold
              }
            }
          }
        : ''}
    
  }

  &:active {
    ${props =>
      props.name !== 'minte-logo'
        ? {
            path: {
              '&:last-child': {
                fill: colors.darkGold
              }
            }
          }
        : ''}
    color: ${colors.darkGold};
  }

  ${borderRadius}
  ${buttonStyle}
  ${space}
  ${width}  
  ${fontSize}
  ${fontWeight}
  ${lineHeight}
  ${flexbox}
  ${background}
`;

function IconButton(props) {
  const { title, name, width, height, textProps, ...restProps } = props;
  return (
    <Wrapper name={name} {...restProps}>
      <SvgIcon name={name} width={width} height={height} />
      {title && (
        <Text ml={3} {...textProps}>
          {title}
        </Text>
      )}
    </Wrapper>
  );
}

IconButton.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  textProps: PropTypes.any
};

IconButton.defaultProps = {
  px: 0,
  py: 0,
  fontSize: 2,
  borderRadius: 4,
  width: 32,
  height: 32
};

export default IconButton;
